import axiosPrivate from "../../../api/axiosPrivate";
import {
  CUSTOM_FORM,
  GET_CUSTOM_FORM,
  UPDATE_CUSTOM_FORM,
  VIEW_CUSTOM_FORM,
} from "../../../api/constant";

const createCustormForm = async (data) => {
  const response = await axiosPrivate.post(CUSTOM_FORM, data);
  return response.data;
};

const getAllForms = async ({pageNum, search}) => {
  const response = await axiosPrivate.get(`${GET_CUSTOM_FORM}?page=${pageNum}&search=${search}`);
  return response.data;
};

const getSingleForm = async (id) => {
  const response = await axiosPrivate.get(`${VIEW_CUSTOM_FORM}/${id}`);
  return response.data;
};

const updateSingleForm = async (data) => {
  const response = await axiosPrivate.post(
    `${UPDATE_CUSTOM_FORM}/${data.id}`,
    data
  );
  return response.data;
};

const formService = {
  createCustormForm,
  getAllForms,
  getSingleForm,
  updateSingleForm,
};

export default formService;
